import EOptionKey from "@/constants/option";
import { Select, SelectItem, Selection } from "@nextui-org/react";

const options = [
  { key: EOptionKey.relevance, label: "Relevance" },
  { key: EOptionKey.low, label: "Price: Low to high" },
  { key: EOptionKey.high, label: "Price: High to low" },
  { key: EOptionKey.rate, label: "Customer review" },
  { key: EOptionKey.nameAZ, label: "Product Name (A - Z)" },
  { key: EOptionKey.nameZA, label: "Product Name (Z - A)" },
];

interface SortingProps {
  value: Selection;
  setValue: (e: Selection) => void;
}

const Sorting: React.FC<SortingProps> = (props) => {
  const { value, setValue } = props;

  return (
    <div className="flex w-[240px] flex-col gap-2">
      <Select
        selectedKeys={value}
        className="max-w-xs"
        onSelectionChange={setValue}
        aria-label="Sorting options"
        radius="none"
      >
        {options.map((option) => (
          <SelectItem key={option.key}>{option.label}</SelectItem>
        ))}
      </Select>
    </div>
  );
};

export default Sorting;
